if (!customElements.get('dyld-how-to-enter')) {
  customElements.define('dyld-how-to-enter', class extends HTMLElement {
    connectedCallback() {
      if (this.moving) return;
      this.wrapper = this.closest('.shopify-section');
      this.details = this.querySelector('details');
      this.media = matchMedia('(max-width: 989px)');
      this.anchor = document.createComment('DYLD entry steps desktop position');
      this.wrapper.before(this.anchor);
      const previous = this.wrapper.previousElementSibling;
      const next = this.wrapper.nextElementSibling;
      this.countdown = previous?.matches('.section-dyld-hero') && next?.matches('.section-dyld-countdown') ? next : null;
      this.hero = this.countdown ? previous : previous?.matches('.section-dyld-countdown') && previous.previousElementSibling?.matches('.section-dyld-hero') ? previous.previousElementSibling : null;
      this.onChange = () => {
        this.moving = true;
        if (this.media.matches && this.hero) this.hero.after(this.wrapper);
        else if (this.countdown) this.countdown.after(this.wrapper);
        else this.anchor.after(this.wrapper);
        this.moving = false;
      };
      this.onSelect = event => { if (this.contains(event.target)) this.details.open = true; };
      this.media.addEventListener('change', this.onChange);
      this.addEventListener('shopify:block:select', this.onSelect);
      this.onChange();
    }
    disconnectedCallback() {
      if (this.moving) return;
      this.media?.removeEventListener('change', this.onChange);
      this.removeEventListener('shopify:block:select', this.onSelect);
      this.anchor?.remove();
    }
  });
}
